export default __webpack_public_path__ + "static/media/oven.7ecc9277.svg";